<div class="payload-viewer" *ngIf="payload || asciiString">

    <div class="payload-buttons p-grid">
        <div class="p-col" *ngIf="showDecodeOptionsToggle">
            <p-selectButton multiple="multiple"
                            [options]="decodeOptions"
                            [(ngModel)]="selectedDecodeOption"
                            (onChange)="toggleDecodeOption()">
            </p-selectButton>
        </div>
        <div *ngIf="showDecoderOptions && showAscii && decoderOptions.length > 0" class="decoder-options p-col">
            Options:
            <p-selectButton multiple="multiple"
                            [options]="decoderOptions"
                            [(ngModel)]="selectedDecoderOption"
                            (onChange)="toggleDecoder()">
            </p-selectButton>
        </div>
    </div>
    <div class="payloads">

        <div class="payload hex" *ngIf="showHex" [ngClass]="{'payload-50': (showAscii && showHex), 'payload-100': !(showAscii && showHex), 'full-height': fullHeight}">
            <code class="hex-line" style="padding-right: 10px; width: auto;"> {{ hexLineNumbers }} </code>
            <code
                class="hex-content" #hex
                [irHighlightTextComp]="transformedAscii"
                [irHexMode]="true"
                [hexString]="hexString"
                [irHighlightTextOptions]="hightlightOptions"
                [irDisplayHex]="(showAscii && showHex)? 'sync' : 'show' "
                [irQuickSearchItems]="quickSearchItems"
                (irLineNumbers)="generateHexLineNumbers($event)"
                (irSelectionPosition)="ascii.highlightSelection($event)">
            </code>
        </div>

        <div class="payload ascii" *ngIf="showAscii" [ngClass]="{'payload-50': (showAscii && showHex), 'payload-100': !(showAscii && showHex)}">
            <code
                class="ascii-content" #ascii
                [irHighlightTextOptions]="hightlightOptions"
                [irHighlightTextComp]="transformedAscii"
                [irRemoveNonPrintable]="true"
                [irDisplayHex]="(showAscii && showHex)? 'sync' : 'show' "
                [irQuickSearchItems]="quickSearchItems"
                (irSelectionPosition)="hex.highlightSelection($event)">
            </code>
        </div>

    </div>
    <div class="p-grid copy-buttons">
        <div class="p-col hex">
            <div class="p-grid p-justify-end">
                <button pButton class="primaryAction" type="button" icon="pi pi-copy" label="Copy HEX" (click)="copyToClipboard()"></button>
            </div>
        </div>
        <div class="p-col">
            <div class="p-grid p-justify-end">
                <button pButton class="primaryAction" type="button" icon="pi pi-copy" label="Copy ASCII" (click)="copyToClipboard('ascii')"></button>
            </div>
        </div>
    </div>
</div>
